// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"DomainsList_contentComponent__KtX80"};